import script from "./DetectCylinder.vue?vue&type=script&setup=true&lang=js"
export * from "./DetectCylinder.vue?vue&type=script&setup=true&lang=js"

import "./DetectCylinder.vue?vue&type=style&index=0&id=25ad53c0&lang=scss"

const __exports__ = script;

export default __exports__